// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/icomoon.eot?h0xqw3", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/icomoon.ttf?h0xqw3", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/icomoon.woff?h0xqw3", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/icomoon.svg?h0xqw3", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&family=Outfit:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#icomoon" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "icomoon";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-], [class*=" icon-"] {
  font-family: "icomoon" !important;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-chevron-right:before {
  content: "\\e901";
}

.icon-quote:before {
  content: "\\e902";
}

.icon-youtube:before {
  content: "\\e903";
}

.icon-facebook:before {
  content: "\\e904";
}

.icon-linkedin:before {
  content: "\\e905";
}

.icon-twitter:before {
  content: "\\e906";
}

.icon-clock:before {
  content: "\\e907";
}

.icon-stats:before {
  content: "\\e90a";
}

.icon-dashboard:before {
  content: "\\e90b";
}

.icon-stock-market:before {
  content: "\\e90c";
}

.icon-instagram:before {
  content: "\\e90d";
}

body {
  padding: 0;
  margin: 0;
  font: 18px/1.555 "Outfit", sans-serif;
}

h1, .h1 h2, h3, h4, h5, h6 {
  font-family: "Inter", sans-serif;
}

h1, .h1 {
  font-size: 70px;
}

h2 {
  font-size: 42px;
}

h3 {
  font-size: 24px;
}

h4 {
  font-size: 22px;
}

h5 {
  font-size: 20px;
}

h6 {
  font-size: 16px;
}

* {
  box-sizing: border-box;
}

#wrapper {
  overflow: hidden;
  position: relative;
}

.container {
  max-width: 1200px;
  padding: 0 15px;
  margin: 0 auto;
}

.btn {
  padding: 18px 20px;
  cursor: pointer;
  font-size: 16px;
  border: none;
  outline: none;
  border-radius: 4px;
}

.btn-primary {
  background-color: #3346E7;
  color: #fff;
  transition: all 0.5s ease;
}
.btn-primary:hover {
  opacity: 0.8;
}
.btn-primary i {
  margin: 0 0 0 15px;
}
.btn-primary i::before {
  color: #fff;
}

.btn-outline {
  background: transparent;
  border: 1px solid #222;
}
.btn-outline i {
  margin: 0 0 0 15px;
}
.btn-outline i::before {
  color: #222;
}

.btn-text {
  background-color: #fff;
  font-weight: 500;
  color: #3346E7;
  position: relative;
  overflow: hidden;
}
.btn-text i {
  margin: 0 0 0 15px;
}
.btn-text i::before {
  color: #222;
}
.btn-text.text-black {
  color: #222;
  transition: all 0.5s ease;
  border: 1px solid #fff;
}
.btn-text.text-black:hover {
  background-color: transparent;
  border: 1px solid #fff;
  color: #fff;
}
.btn-text.text-black:hover i::before {
  color: #fff;
}

.hero-text {
  max-width: 825px;
  margin: 0 auto;
}
.hero-text h1 {
  margin: 0 0 10px 0;
}
.hero-text h2 {
  margin: 0 0 10px 0;
}
.hero-text p {
  margin: 0 0 32px 0;
}
.hero-text .btn-outline {
  transition: all 0.5s ease;
}
.hero-text .btn-outline:hover {
  color: #fff;
  background-color: #3346E7;
  border: 1px solid #3346E7;
}
.hero-text .btn-outline:hover i {
  transition: all 0.5s ease;
}
.hero-text .btn-outline:hover i::before {
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/landing_page/common.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;EACtB,4CAAsC;EACtC,mPAAoO;EACpO,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&family=Outfit:wght@100;200;300;400;500;600;700;800;900&display=swap');\n\n@font-face {\n  font-family: \"icomoon\";\n  src: url(\"./fonts/icomoon.eot?h0xqw3\");\n  src: url(\"./fonts/icomoon.eot?h0xqw3#iefix\") format(\"embedded-opentype\"), url(\"fonts/icomoon.ttf?h0xqw3\") format(\"truetype\"), url(\"fonts/icomoon.woff?h0xqw3\") format(\"woff\"), url(\"fonts/icomoon.svg?h0xqw3#icomoon\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n[class^=icon-], [class*=\" icon-\"] {\n  font-family: \"icomoon\" !important;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-chevron-right:before {\n  content: \"\\e901\";\n}\n\n.icon-quote:before {\n  content: \"\\e902\";\n}\n\n.icon-youtube:before {\n  content: \"\\e903\";\n}\n\n.icon-facebook:before {\n  content: \"\\e904\";\n}\n\n.icon-linkedin:before {\n  content: \"\\e905\";\n}\n\n.icon-twitter:before {\n  content: \"\\e906\";\n}\n\n.icon-clock:before {\n  content: \"\\e907\";\n}\n\n.icon-stats:before {\n  content: \"\\e90a\";\n}\n\n.icon-dashboard:before {\n  content: \"\\e90b\";\n}\n\n.icon-stock-market:before {\n  content: \"\\e90c\";\n}\n\n.icon-instagram:before {\n  content: \"\\e90d\";\n}\n\nbody {\n  padding: 0;\n  margin: 0;\n  font: 18px/1.555 \"Outfit\", sans-serif;\n}\n\nh1, .h1 h2, h3, h4, h5, h6 {\n  font-family: \"Inter\", sans-serif;\n}\n\nh1, .h1 {\n  font-size: 70px;\n}\n\nh2 {\n  font-size: 42px;\n}\n\nh3 {\n  font-size: 24px;\n}\n\nh4 {\n  font-size: 22px;\n}\n\nh5 {\n  font-size: 20px;\n}\n\nh6 {\n  font-size: 16px;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n#wrapper {\n  overflow: hidden;\n  position: relative;\n}\n\n.container {\n  max-width: 1200px;\n  padding: 0 15px;\n  margin: 0 auto;\n}\n\n.btn {\n  padding: 18px 20px;\n  cursor: pointer;\n  font-size: 16px;\n  border: none;\n  outline: none;\n  border-radius: 4px;\n}\n\n.btn-primary {\n  background-color: #3346E7;\n  color: #fff;\n  transition: all 0.5s ease;\n}\n.btn-primary:hover {\n  opacity: 0.8;\n}\n.btn-primary i {\n  margin: 0 0 0 15px;\n}\n.btn-primary i::before {\n  color: #fff;\n}\n\n.btn-outline {\n  background: transparent;\n  border: 1px solid #222;\n}\n.btn-outline i {\n  margin: 0 0 0 15px;\n}\n.btn-outline i::before {\n  color: #222;\n}\n\n.btn-text {\n  background-color: #fff;\n  font-weight: 500;\n  color: #3346E7;\n  position: relative;\n  overflow: hidden;\n}\n.btn-text i {\n  margin: 0 0 0 15px;\n}\n.btn-text i::before {\n  color: #222;\n}\n.btn-text.text-black {\n  color: #222;\n  transition: all 0.5s ease;\n  border: 1px solid #fff;\n}\n.btn-text.text-black:hover {\n  background-color: transparent;\n  border: 1px solid #fff;\n  color: #fff;\n}\n.btn-text.text-black:hover i::before {\n  color: #fff;\n}\n\n.hero-text {\n  max-width: 825px;\n  margin: 0 auto;\n}\n.hero-text h1 {\n  margin: 0 0 10px 0;\n}\n.hero-text h2 {\n  margin: 0 0 10px 0;\n}\n.hero-text p {\n  margin: 0 0 32px 0;\n}\n.hero-text .btn-outline {\n  transition: all 0.5s ease;\n}\n.hero-text .btn-outline:hover {\n  color: #fff;\n  background-color: #3346E7;\n  border: 1px solid #3346E7;\n}\n.hero-text .btn-outline:hover i {\n  transition: all 0.5s ease;\n}\n.hero-text .btn-outline:hover i::before {\n  color: #fff;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
